<template>
  <Modal
    class="spaceModal"
    :isOpen="isOpen"
    :buttons="{
      column: false,
      data: [
        {
          label: space ? $t('app.campaign.settings.buttons.cancel') : $t('app.modals.spaceEdit.buttons.create.cancel'),
          class: 'secondary',
        },
        {
          label: space ? $t('app.campaign.settings.buttons.save') : $t('app.modals.spaceEdit.buttons.create.confirm'),
          class: 'green',
          disabled: state.space?.name?.length < 2 || state.space?.name?.length > 50,
        },
      ],
    }"
    :title="space?.name || $t('app.modals.spaceEdit.createTitle')"
    @close="close()"
    @callbackBtn1="close()"
    @callbackBtn2="save()"
  >
    <template #extra>
      <h4>{{ $t("app.modals.spaceEdit.title") }}</h4>
      <VForm :displayErrors="false" :callback="save">
        <template #form-body>
          <VField :label="$t('app.modals.spaceEdit.spaceName.label')" :placeholder="$t('app.modals.spaceEdit.spaceName.placeholder')" name="space-name" v-model="state.space.name" rules="required|max:50|min:2" :displayError="true" />
        </template>
      </VForm>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { reactive, watch } from "vue";
import { useRoute } from "vue-router";
import { useToast } from "vue-toastification";
import { useCreateSpace, useEditSpace } from "@/queries/space.query";

const toast = useToast();
const route = useRoute();
const { t } = useI18n();

const { mutateAsync: createSpace } = useCreateSpace();
const { mutateAsync: editSpace } = useEditSpace();

const emits = defineEmits(["close", "created"]);

const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
  space: {
    type: Object,
    required: false,
  },
  action: {
    type: String,
    required: true,
  },
});

const state = reactive({
  space: null,
});

async function save() {

  if (props.action === "create") {
    await createSpace({
      organisationId: route.params.companyId as string,
      name: state.space.name,
      imageId: undefined,
    }, {
      onSuccess: (data) => {
        toast.success(t('app.toasts.success'));
        emits("created", data);
      },
      onError: () => {
        toast.error(t('other.error.ERROR_UNKNOWN'));
      },
    });
  } else {
    await editSpace({
      organisationId: route.params.companyId as string,
      name: state.space.name,
      imageId: undefined,
      spaceId: props.space.workspace_id,
    }, {
      onSuccess: () => {
        toast.success(t('app.toasts.success'));
      },
      onError: () => {
        toast.error(t('other.error.ERROR_UNKNOWN'));
      },
    });
  }

  close();
}

function close() {
  state.space = null;
  emits("close");
}

watch(props, () => {
  state.space = { ...props.space, name: props.space?.name, image_file: null };
});
</script>
